// 관리자 콘솔 보호 라우트.
// 세션이 없으면 /login 으로 보낸다.
// 세션은 있지만 비밀번호 변경이 필요한 경우(must_change_password) 다른 라우트 진입을 차단하고 /change-password 로 돌려보낸다.
// /change-password 자체는 본 가드를 통과해야 변경 폼을 띄울 수 있으므로 path 비교로 분기한다.

import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuthStore } from "@/stores/adminAuthStore.ts";

interface Props {
  children: React.ReactNode;
}

// 관리자 인증 라우트 가드.
// 본 컴포넌트로 감싼 자식만 인증된 관리자가 접근 가능하다.
export default function AdminProtectedRoute({ children }: Props) {
  const session = useAdminAuthStore((s) => s.session);
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (session.changePasswordRequired && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}
